<template>
  <Modal
    v-model="visible"
    :footer-hide="true"
    transfer
    :mask-closable="false"
    class="my-modal"
    :width="merchantList.length == 2 || merchantList.length == 4 ? '700px' : '1020px'"
  >
    <div class="title" v-if="type == 'resetPwd'">请选择企业重置密码</div>
    <div class="title" v-else>请选择要登录的企业</div>
    <div class="merchant-list" :class="{'small': merchantList.length == 2 || merchantList.length == 4}">
      <div class="item" v-for="(bean, i) in merchantList" :key="i" @click="select(bean)">
        <img src="@static/images/login/merchant-icon.png" alt />
        <p>{{ bean.merName }}</p>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      type: '', //resetPwd 重置密码
      merchantList: [] //商户列表
    };
  },
  methods: {
    select(bean) {
      this.visible = false;
      this.$emit('select', bean);
    },
    open(merchantList, type) {
      this.type = type;
      this.merchantList = merchantList;
      this.visible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './selectMerchantModal.scss';
</style>
